var oldFetch = window.fetch;
var logoutTimer = null;

const responseToJson = response => {
  if (!response.ok) throw Error(response.statusText);
  return response.json();
};

function inactiveTimer(backendRoutes) {
  const logOutUser = () => {
    oldFetch(backendRoutes.TimerExpiredLogout, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(responseToJson)
    .then(() => {
      sessionStorage.clear();
      logoutTimer = null;
      window.location = backendRoutes.LoginPage;
    })
    .catch(e => {
      sessionStorage.clear();
      logoutTimer = null;
      window.location = backendRoutes.LoginPage;
    });
  };

  window.fetch = function(url, options) {
    let requestHistory = JSON.parse(localStorage.getItem('requestHistory'));
    if (requestHistory === null) {
      requestHistory = [];
    }

    if (requestHistory.length == 25) {
      requestHistory.shift();
    }

    requestHistory.push({ url, options, time: new Date() });

    localStorage.setItem('requestHistory', JSON.stringify(requestHistory));

    if (logoutTimer !== null) clearTimeout(logoutTimer);

    logoutTimer = setTimeout(logOutUser, 1000 * 60 * 30);

    return oldFetch(url, options);
  }
}

export { inactiveTimer };
